<!-- css -->
<style type="text/css" scoped>
.topup {
  display: flex;
  flex-direction: column;
  align-items: center;
  /*justify-content: center;*/
  height: 100%;
  padding-top: 100px;
}

.surplus {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.surplus-title {
  height: 18px;
  font-size: 16px;
  color: #999999;
}

.surplus-count {
  height: 43px;
  margin-top: 10px;
  font-size: 40px;
  color: #333333;
}

.action {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.action-info {
  margin-top: 60px;
  height: 100px;
  width: 240px;
  border-style: solid;
  border-color: #F9A624;
  border-width: 1px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.action-info-detail {
  font-size: 30px;
  color: #F9A624;
}

.action-info-price {
  font-size: 16px;
  color: #333333;
  margin-top: 10px;
}

.action-tip {
  font-size: 10px;
  color: #CCCCCC;
}

.action-topup {
  margin-top: 40px;
  color: #FFFFFF;
  font-size: 16px;
  width: 160px;
  height: 40px;
  background-color: #F9A624;
  border-style: none;
  border-radius: 5px;
  outline: none;
}

</style>
<!-- html -->
<template>
  <div class="topup">
    <!-- 硬币余额 -->
    <div class="surplus">
      <span class="surplus-title">钢镚余额</span>
      <span class="surplus-count">{{coin}}</span>
    </div>
    <!-- 充值 -->
    <div class="action">
      <div class="action-info">
        <span class="action-info-detail">10<font size="2">/币</font></span>
        <span class="action-info-price">&yen;1.00</span>
        <!-- <span class="action-tip">目前仅支持10金币单次兑换</span> -->
      </div>
      <button class="action-topup" @click.stop="topupHandler">确认兑换</button>
    </div>
  </div>
</template>
<!-- javascript -->
<script type="text/javascript">
import Fetch from '../../common/fetch'
import Storage from '../../common/storage'
import Wechat from '../../common/wechat'
import { Toast } from 'mint-ui'

export default {
  name: 'topup',
  computed: {
    userInfo: function(argument) {
      return JSON.parse(Storage.queryItem('userInfo'))
    },
    coin: function(argument) {
      let val = Storage.queryItem('coin')
      if (val === null) {
        return 0
      } else {
        if (typeof parseInt(val) === 'number') {
          return parseInt(val)
        } else {
          return 0
        }
      }
    }
  },
  data: function() {
    return {
      isPayed: false
    }
  },
  mounted: function() {},
  methods: {
    // 余额查询
    checkBalance: function(argument) {
      let vm = this
      Fetch.loadCheckBalance({ openid: this.userInfo.openid }).then(resp => {
        console.log(resp)
        if (resp.code === 0) {
          vm.coin = resp.data
          Storage.setItem('coin', resp.data)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 支付动作
    topupHandler: function(evt) {
      this.loadWxPayReq()
    },
    // 微信支付
    loadWxPayReq: function(argument) {
      let _this = this
      let userInfo = JSON.parse(Storage.queryItem('userInfo'))
      let option = {
        openid: userInfo.openid,
        token: userInfo.token
      }
      Fetch.loadWxpayJsapi(option).then(function(resp) {
        if (resp.code === 0) {
          Wechat.payAYuan(resp.data, function(isSucceed) {
            if (isSucceed) {
              Toast({
                message: '支付成功'
              })
              // 查询余额
              _this.checkBalance()
            } else {
              Toast({
                message: '支付失败'
              })
            }
          })
        }
      }).catch(function(error) {
        console.log(error)
        Toast({
          message: '支付失败'
        })
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// NITopup.vue?19e74b9c